/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import {vuetifyPresets} from '@/shell/plugins/vuetifyPresets';

Vue.use(Vuetify);

export default new Vuetify(vuetifyPresets);
